var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    _vm._b({}, "div", _vm.$attrs, false),
    [
      _c(
        "v-tooltip",
        {
          attrs: { bottom: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on, attrs }) {
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: {
                            icon: "",
                            small: _vm.small,
                            color: _setup.copied ? "success" : undefined,
                          },
                          on: { click: _setup.copyToClipboard },
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _c("v-icon", { attrs: { small: _vm.small } }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _setup.copied ? "mdi-check" : "mdi-content-copy"
                            ) +
                            " "
                        ),
                      ]),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c("span", [
            _vm._v(_vm._s(_setup.copied ? "Copiado!" : _vm.tooltipText)),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }